<template>
  <CContainer fluid>
        <CRow>
          <CCol col="sm-6">
            <CInput 
              label="Buscar:"
              addLabelClasses="text-muted font-weight-bold"
              :value.sync="searchWord" 
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" @click="getData(1)">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#" @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
        </CRow>
        <CDataTable 
          hover 
          :items="items" 
          :fields="fields"
          :items-per-page="itemsPerPage" 
          :responsive=true >
          <template #documento="{item}">
            <td>
              <h4>{{ item.numero }}</h4>
            </td>
          </template>
          <template #empresa="{item}">
              <td>
                <div v-if="TypeFilter === 'V'">
                  <span><CIcon name="cil-building" class="mr-1"/>{{ item.empresa }}</span>
                </div>
                <div v-if="TypeFilter === 'V'">
                  <span><i class="bi bi-postcard mr-1" style="height: 1rem; width: 1rem; display: inline-block;"></i>{{ item.identificacion }}</span>
                </div>
                <div v-if="TypeFilter === 'C'">
                  <span>
                    <i class="bi bi-person-workspace mr-1" style="height: 1rem; width: 1rem; display: inline-block;"></i>
                    {{ item.empleado }}
                  </span>
                </div>
              </td>
          </template>
          <template #fechas="{item}">
            <td>
              <div>
                  <span>
                    <CIcon name="cil-calendar" class="mr-1"/>
                    {{ moment(item.fecha_Emision).format('DD/MM/YYYY') }}
                  </span>
              </div>
              <div v-if="TypeDocument === 'C'">
                  <span>
                    <CIcon name="cil-calendar" class="mr-1"/>
                    {{ moment(item.fecha_Vencimiento).format('DD/MM/YYYY') }}
                  </span>
              </div>
              <div v-if="TypeDocument === 'C'">
                  <span>
                    <CIcon name="cil-av-timer"/>
                    {{ item.dias_Validez }}</span>
              </div>
            </td>
          </template>
          <template #estado="{item}">
            <td>
              <div class="d-flex justify-content-end">
                <span>${{ formatter.format(item.valor_Total) }}</span>
              </div>
              <div>
                <!-- <a href="#">
                  <i class="bi" :class="activatesBilling(item)" style="height: 1rem; width: 1rem; display: inline-block;"></i>
                </a> -->
                <p>
                  <CBadge :color="getBadgeColorOrderState(item.estado_Pedido)" class="text-white">
                    {{ orderState[item.estado_Pedido] }}
                  </CBadge>
                </p>
              </div>
            </td>
          </template>
          <template #info="{item}">
            <td>
              <a href="#"
                style="text-decoration: none;"
                class="mb-2 p-2"
                @click="toggleDocument($event, item)">
                <CIcon class="text-dark" :name="item._toggled ? 'cil-chevron-circle-up-alt' : 'cil-chevron-circle-down-alt'"/>
              </a>
            </td>
          </template>
          <template #details="{item}">
            <CCollapse class="my-3" :show="item._toggled">
              <CCol col="sm-12">
                <div class="d-flex justify-content-end">
                  <a href="#" 
                    class="m-2" 
                    v-c-tooltip="'Detalle del Documento'"
                    @click="() => {}">
                    <i class="bi bi-journal-text text-info h4"></i>
                  </a>

                  <a href="#" 
                    class="m-2" 
                    v-c-tooltip="'Seguimiento Pedido'" 
                    @click="(event) => openPanelTracking(event, item.id_Pedido)">
                    <Icon icon="hugeicons:delivery-tracking-01" class="text-s3fuchsia h4" />
                  </a>

                  <a href="#" 
                    class="m-2" 
                    v-c-tooltip="'Imprimir pedido PDF'"
                    @click="printOrderPDF(item.id_Pedido)">
                    <i class="bi bi-file-earmark-pdf text-danger h4"></i>
                  </a>
                </div>

              </CCol>
              <CCol col="sm-6" class="d-inline-block" style="vertical-align: top;">
                <div>
                  <strong>Orden Compra:</strong>{{ item.orden_Compra }}
                </div>
                <div>
                  <strong>Comentarios:</strong>
                </div>
                <div>
                  {{ item.comentario_01 }}
                </div>
                <div>
                  {{ item.comentario_02 }}
                </div>
              </CCol>
              <CCol col="sm-6" class="d-inline-block" style="vertical-align: top;">
                <div class="ml-4 row">
                  <strong class="col-sm-6">Vr. Mercancía: </strong>
                  <span class="col-sm-6 text-right">${{ formatter.format(item.valor_Mercancia) }}</span>
                </div>
                <div class="ml-4 row">
                  <strong class="col-sm-6">Vr. IVA: </strong>
                  <span class="col-sm-6 text-right">${{ formatter.format(item.valor_Iva) }}</span>
                </div>
                <div class="ml-4 row">
                  <strong class="col-sm-6">Vr. Total: </strong>
                  <span class="col-sm-6 text-right">
                    <strong>
                      ${{ formatter.format(item.valor_Total) }}
                    </strong>
                  </span>
                </div>
              </CCol>
            </CCollapse>
          </template>
        </CDataTable>

        <CPagination 
          size="sm" 
          class="d-flex justify-content-center"
          :activePage.sync="page" 
          :pages="pageCount" 
          @update:activePage="(value, a) => getData(value, searchWord)">
        </CPagination>

      <RightSideBar 
        size="md"
        class="bg-s3grey" 
        :show="showPanelTracking">
        <CContainer>
          <CCard class="mt-3">
            <CCardHeader>
              <CCardTitle>
                Seguimiento de Pedido
              </CCardTitle>
            </CCardHeader>
            <CCardBody>
                <ul class="metro_tmtimeline">
                  <li v-for="(reg, idx) in estados" :class="reg.color" :key="idx">
                      <div class="metro_tmicon">
                        <i class="bi bi-check-lg"></i>
                      </div>
                      <div class="metro_tmlabel">
                          <h3>{{ reg.tipo_Documento }}</h3>
                          <div>
                            <span>{{ reg.prefijo }} {{ reg.numero }}</span>
                          </div>
                          <span>{{ moment(reg.fecha_Emision).format("DD/MM/YYYY") }}</span>
                      </div>
                  </li>
                </ul>
            </CCardBody>
            <CCardFooter class="d-flex justify-content-center">
              <CButton 
                color="primary" 
                @click="showPanelTracking=false">
                <CIcon name="cil-x-circle"/>
                <span class="align-middle ml-2">Cerrar</span>
              </CButton>
            </CCardFooter>
          </CCard>
        </CContainer>
      </RightSideBar>
      
      <RightSideBar 
        class="bg-white" 
        :show="showRightSidebarComments">
        <VerticalDynamicForm title="Comentarios" :fields="commentsFields" />
        <span>Hola</span>
        <div class="d-flex justify-content-center">
          <!-- <CButton
            square 
            color="success"
            class="d-inline-block"
            :class="isValidForm ? '' : 'disabled'"
            :disabled="!isValidForm"
            @click="saveTracking()">
            <CIcon name="cil-check-circle"/>
            <span class="align-middle mx-2">Guardar</span>
          </CButton> -->
          <CButton
            color="danger"
            variant="outline"
            class="mr-2 d-inline-block"
            @click="(e) => {
              e.stopPropagation()
              showRightSidebarComments = false
            }">
            <CIcon name="cil-x-circle"/>
            <span class="align-middle mx-2">Cancelar</span>
          </CButton>
        </div>
      </RightSideBar>

    <CElementCover v-show="loading" />
  </CContainer>
</template>

<script>
  import moment from "moment";
  import { formatter } from "../../general";
  import { downloadFileObject } from "../../api";
  import { dataGridCotizacionesPedidos } from "../../apiDataGrids";
  import { descargarCotizacionPDF } from "../../apiReports";
  import { dataSeguimientoCotizacion } from "../../apiData";

  import { Icon } from "@iconify/vue2";
  import RightSideBar from "../containers/RightSideBar.vue";
  import VerticalDynamicForm from "../containers/VerticalDynamicForm.vue"

  const fields = [
    { key: 'documento', label: 'Número', _style: 'text-align:center' },
    { key: 'empresa', label: 'Empresa', _style: 'text-align:center' },
    { key: 'fechas', label: 'Fecha', _style: 'text-align:center' },
    { key: 'estado', label: 'Estado', _style: 'text-align:center' },
    { key: 'info', label: '' }
  ]

  export default ({
    name: 'OrdersQuotes',
    data() {
        return {
          formatter,
          loading: false,
          page: 1,
          pageCount: 1,
          itemsPerPage: 5,
          searchWord: "",
          showRightSidebarComments: null,
          showPanelTracking: null,
          fields,
          commentsFields: [
            { 
              key: "comentario01",
              value: "",
              type: "textarea",
              label: ""
            },
            { 
              key: "comentario02",
              value: "",
              type: "textarea",
              label: ""
            }
          ],
          items: [],
          estados: [],
          orderState: {
            PE: 'Pendiente',
            TO: 'Facturado',
            CA: 'Cancelado'
          }
        }
    },
    props: {
      TypeDocument: String,
      TypeFilter: String,
      IdEmployee: String,
      IdCustomer: String
    },
    components: {
      Icon,
      RightSideBar,
      VerticalDynamicForm
    },
    methods: {
      moment,
      async getData(page, search) {
        this.loading = true;
        this.searchWord = search;

        try {
          const { count, results } = await dataGridCotizacionesPedidos(
            this,
            this.TypeDocument,
            this.IdEmployee,
            this.IdCustomer,
            page,
            search
          )

          this.pageCount = parseInt(count / this.itemsPerPage)
          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++
          }

          this.items = results
        } catch(error) {
          console.log(error)
          this.$store.commit('setAlert', {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      async openPanelTracking(e, idDocument) {
        e.stopPropagation()

        this.showPanelTracking = true

        const { response } = await dataSeguimientoCotizacion(this, idDocument)

        this.estados = response

        console.log(idDocument);

      },
      async printOrderPDF(idDocument) {
        this.loading = true

        try {
          const { response } = await descargarCotizacionPDF(this, idDocument)
          const { nombreArchivo, contenidoArchivo } = response

          downloadFileObject(nombreArchivo, "pdf", contenidoArchivo)
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Ocurrio un error al generar el archivo PDF",
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      toggleDocument(e, item){
        e.stopPropagation()

        this.$set(item, '_toggled', !item._toggled)
        this.$nextTick(() => { })
      },
      getBadgeColorOrderState(orderState) {
        if (orderState === 'TO') return "success"
        if (orderState === 'PE') return "warning"
        if (orderState === 'CA') return "danger"
      },
      openRightSidebarComments(event, item) {
        event.stopPropagation()

        console.log(item);

        this.showRightSidebarComments = true
      }
    },
    computed: {
      // orderState(statusDocument) {
      //   let titleStatusDocument = "";

      //   if (statusDocument === "PE") {
      //     titleStatusDocument = "Pendiente";
      //   }

      //   return titleStatusDocument;
      // }
    },
    mounted() {
      this.getData();
    }
  })
</script>
